import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './features/user/userSlice';
import cartReducer from './features/cart/cartSlice';
import recentlyViewedReducer from './features/product/recentlyViewedSlice';
import orderReducer from './features/order/orderSlice';
import authReducer from './features/auth/authSlice';
import mandateReducer from './features/paystack/mandateSlice';
import deliveryReducer from './features/order/deliveryAddressSlice';
import fullPaymentReducer from './features/order/fullPaymentSlice';
import addressVerificationReducer from './features/user/verificationSlices/addressVerifcationSlice';
import debtVerificationReducer from './features/user/verificationSlices/debtVerificationSlice';
import searchReducer from './features/product/productSearchSlice';

const appReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  recentlyViewed: recentlyViewedReducer,
  order: orderReducer,
  delivery: deliveryReducer,
  auth: authReducer,
  mandate: mandateReducer,
  fullPayment: fullPaymentReducer,
  addressVerification: addressVerificationReducer,
  debtVerification: debtVerificationReducer,
  search: searchReducer,
});

//  Root reducer that resets everything on LOGOUT
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined; // completely reset Redux state
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'cart',
    'user',
    'recentlyViewed',
    'order',
    'delivery',
    'auth',
    'mandate',
    'fullPayment',
    'addressVerification',
    'debtVerification',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
